import React from 'react';
import { usePatientService } from '~/services';
import { ReminderFeed } from '~/components/Reminders';

interface QualityGapRemindersProps {
    qualityGapId: number;
    patientId: number;
    addReminderOpen?: boolean;
}

export function QualityGapReminders({
    qualityGapId,
    patientId,
    addReminderOpen = false,
}: QualityGapRemindersProps) {
    const { updateQualityGap } = usePatientService();
    async function performAdd(description: string, dueDate: string) {
        await updateQualityGap(qualityGapId, patientId, {
            tasks: [{ description, due_at: dueDate }],
        });
    }
    return (
        <ReminderFeed
            performAdd={performAdd}
            loadEntity={`quality_gap.id=${qualityGapId}`}
            addReminderOpen={addReminderOpen}
            isPCMView
        />
    );
}
